import { useEffect } from 'react';

export default function NoindexTag() {
  useEffect(() => {
    document.head.insertAdjacentHTML('afterbegin', `<meta name="robots" content="noindex">`);

    return () => {
      document.querySelector('meta[content="noindex"]').remove();
    };
  }, []);

  return null;
}
